<div *ngIf="treatment" class="contact-upper-component field-font-small">
    <app-treatment-logo [treatment]="treatment" [contact]="contact"></app-treatment-logo>
</div>